import React, { useState, useRef, useEffect } from 'react';
import IconInfo from './IconInfo';

export default function InfoBtn({ children, align = 'left' }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const h = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, [open]);

  return (
    <div ref={ref} style={{ position: 'relative', display: 'inline-block' }}>
      <button
        onClick={() => setOpen(o => !o)}
        style={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer',
          color: 'var(--ink-3)', background: 'none', border: 'none', padding: '0 2px' }}>
        <IconInfo size={14}/>
      </button>
      {open && (
        <div style={{
          position: 'absolute',
          ...(align === 'right' ? { right: 0 } : { left: 0 }),
          top: '100%', zIndex: 100,
          background: 'var(--surface)', border: '.5px solid var(--hair)', borderRadius: 4,
          padding: '12px 14px', minWidth: 260, maxWidth: 400,
          fontSize: 11, color: 'var(--ink-2)', lineHeight: 1.6,
          boxShadow: '0 2px 8px rgba(0,0,0,.1)',
        }}>
          {children}
        </div>
      )}
    </div>
  );
}
